exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".appstore {\n  position: relative;\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  margin-top: 30px !important;\n}\n.appstore .download-guide {\n  text-align: center;\n  position: absolute;\n  top: 10px;\n  width: 100%;\n}\n.appstore .download-guide img {\n  height: 16px;\n}\n.appstore .btn-download-group {\n  margin: 36px auto 0;\n  padding: 0 0 10px 0;\n  display: flex;\n  justify-content: space-between;\n  width: 450px;\n}\n.appstore .btn-download-group img {\n  width: 214px;\n}\n.mobile .appstore a {\n  margin: 0 auto;\n  display: block;\n  font-size: 18px;\n  line-height: 56px;\n  text-align: center;\n  font-weight: bold;\n  height: 56px;\n  width: 240px;\n  border-radius: unset !important;\n  box-shadow: unset !important;\n  background-color: unset !important;\n  color: unset !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/stylus-loader!./node_modules/vue-loader/lib??vue-loader-options!./src/components/common/Appstore.vue?vue&type=style&index=0&id=0384e178&lang=stylus
// module id = 208
// module chunks = 2 3 4 6 7 15 16